import Page, {
    getStaticPaths as getStaticPagePaths,
    getStaticProps as getStaticPageProps,
} from '../components/pages/Page';

export default Page;

export const getStaticProps = getStaticPageProps;
export const getStaticPaths = getStaticPagePaths;
